import React, { Component } from "react";
import "./style.css";
import { Table, Card, Row } from "react-bootstrap";
import FeedbackViewModal from "../Feedback/FeedbackViewModal";
var dateFormat = require("dateformat");

class Feedback extends Component {
  constructor(props) {
    super(props);
    this.state = {
      feedbkShow: false
    };
  }
  componentDidMount() {
    this.props.feedbkList();
  }

  handleFeedbkView = item => {
    this.setState({
      feedbkShow: true,
      feedbkDtls: item
    });
  };

  handleCloseFeedbk = () => {
    this.setState({ feedbkShow: false });
  };

  render() {
    //  console.log("feedbk details-----", this.props.fedbckDtlsList)

    const count = this.props.fedbckDtlsCount && this.props.fedbckDtlsCount;
    return (
      <div>
        <Card>
          <Card.Header>
            <h3>FeedBack</h3>
          </Card.Header>
          <Card.Body>
            <div>
              <Row>
                <div className="feedbkRecord">
                  <i
                    className="cui-note icons"
                    style={{ fontSize: "20px" }}
                  ></i>
                  <span style={{ padding: "5px" }}>{count}</span>
                  <p>Records</p>
                </div>
              </Row>
            </div>
            <div>
              <Table responsive bordered>
                <thead>
                  <tr>
                    <th>Sl No</th>
                    <th>Feedback By</th>
                    <th>Feedback For</th>
                    <th>Created Date</th>
                    <th>FeedBack</th>
                    <th>Rating</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.fedbckDtlsList &&
                    this.props.fedbckDtlsList.map((item, i) => (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td className="feedbackCap">
                          {item.userId !== null && item.userId.name}
                        </td>
                        <td className="feedbackCap">
                          {/* {item.orgId !== null && item.orgId.name} */}
                        </td>
                        <td className="feedbackCap">
                          {item.createdAt !== null &&
                            dateFormat(item.createdAt, "mediumDate")}
                        </td>
                        <td
                          className="feedbackCap"
                          // style={{ width: "400px", wordBreak: "break-word" }}
                        >
                          {item.feedback !== null && item.feedback}
                        </td>
                        <td className="feedbackCap">
                          {item.rating !== null && item.rating}
                        </td>

                        <td className="feedbackViewIcon">
                          <div>
                            <i
                              className="fa fa-eye fa-lg "
                              onClick={() =>
                                this.handleFeedbkView({ item: item })
                              }
                            ></i>
                            <FeedbackViewModal
                              show={this.state.feedbkShow}
                              handleClose={this.handleCloseFeedbk}
                              feedbkDtls={this.state.feedbkDtls}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </div>
          </Card.Body>
        </Card>
      </div>
    );
  }
}

export default Feedback;
